import BusinessOperationTable from "./BusinessOperationTable";

const BusinessOperation = () => {
  return (
    <>
      <BusinessOperationTable />
    </>
  );
};

export default BusinessOperation;
